<template>
  <div class="py-32">
    <Container>
      <div>
        <h1
          class="text-4xl md:text-5xl font-bold mb-12 text-gray-900 dark:text-white"
        >
          {{ t("legal.privacy.title") }}
        </h1>

        <div
          class="prose dark:prose-invert max-w-none space-y-8 text-gray-600 dark:text-gray-300"
        >
          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.privacy.s1_title") }}
            </h2>
            <p>
              {{ t("legal.privacy.s1_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.privacy.s2_title") }}
            </h2>
            <p>
              {{ t("legal.privacy.s2_content1") }}
            </p>
            <p>
              {{ t("legal.privacy.s2_content2") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.privacy.s3_title") }}
            </h2>
            <p>{{ t("legal.privacy.s3_intro") }}</p>
            <ul class="list-disc pl-5 space-y-2">
              <li>
                {{ t("legal.privacy.s3_item1") }}
              </li>
              <li>
                {{ t("legal.privacy.s3_item2") }}
              </li>
              <li>
                {{ t("legal.privacy.s3_item3") }}
              </li>
              <li>
                {{ t("legal.privacy.s3_item4") }}
              </li>
              <li>{{ t("legal.privacy.s3_item5") }}</li>
            </ul>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.privacy.s4_title") }}
            </h2>
            <p v-html="t('legal.privacy.s4_content')"></p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.privacy.s5_title") }}
            </h2>
            <p>
              {{ t("legal.privacy.s5_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.privacy.s6_title") }}
            </h2>
            <p>
              {{ t("legal.privacy.s6_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.privacy.s7_title") }}
            </h2>
            <p>
              {{ t("legal.privacy.s7_content") }}
            </p>
          </section>

          <div
            class="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700 text-sm text-gray-500"
          >
            {{ t("legal.cgv.updated") }}
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
useSeoMeta({
  title: `${t("legal.privacy.title")} - xPirience`,
  description: t("legal.cgv.updated"),
});
</script>
